var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.jobList.length
    ? _c(
        "div",
        { staticClass: "similars-slider" },
        [
          _vm._t("similarJobsTitle"),
          _vm._v(" "),
          _c("div", { staticClass: "similars-slider__arrow-wrap" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "swiper",
                    rawName: "v-swiper:mySwiper",
                    value: _vm.SWIPER_OPTIONS,
                    expression: "SWIPER_OPTIONS",
                    arg: "mySwiper",
                  },
                ],
              },
              [
                _c(
                  "div",
                  { staticClass: "swiper-wrapper" },
                  _vm._l(_vm.jobList, function (job, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "swiper-slide",
                        on: { key: index },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "similars-slider-card",
                            attrs: { href: "/karrier/jobs?jobId=" + job.id },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "similars-slider-card__job" },
                              [_vm._v(_vm._s(job.title))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "similars-slider-card__location" },
                              [_vm._v(_vm._s(job.location))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "similars-slider-card__employer" },
                              [_vm._v(_vm._s(job.company))]
                            ),
                            _vm._v(" "),
                            job.labels.length
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "similars-slider-card-labels",
                                  },
                                  _vm._l(
                                    job.labels,
                                    function (label, labelIndex) {
                                      return _c(
                                        "span",
                                        {
                                          key: labelIndex,
                                          staticClass:
                                            "similars-slider-card-labels__item",
                                        },
                                        [_vm._v(_vm._s(label))]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "swiper-button-prev",
                    attrs: { slot: "button-prev" },
                    slot: "button-prev",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "similars-slider-arrow similars-slider-arrow--prev",
                        attrs: { type: "button" },
                      },
                      [_vm._v("előző")]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "swiper-button-next",
                    attrs: { slot: "button-next" },
                    slot: "button-next",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "similars-slider-arrow similars-slider-arrow--next",
                        attrs: { type: "button" },
                      },
                      [_vm._v("következő")]
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm._t("allJobsLink"),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }